import { Outlet } from "react-router-dom";

const MainNotes = () => {
    return(
        <div className="w-full h-full">
            <Outlet/>
        </div>
    )
}
export default MainNotes;